/* NB FAQ — topic bar, search, popular links, copy link and deep links.
   Clicks never change the URL; an incoming #topic or #q-... link still opens its answer.
   Reads NB FAQ Hub settings and every NB FAQ Topic section on the page. */

(function () {
  'use strict';

  if (window.nbFaqHub) return;
  window.nbFaqHub = true;

  var state = null;

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function normalise(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function headerBottom() {
    var header = document.querySelector('.m-header__wrapper') || document.querySelector('.m-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    return rect.bottom > 0 ? Math.round(rect.bottom) : 0;
  }

  /* Topics: a section with "Continue the topic above" joins the previous one. */
  function collectGroups() {
    var groups = [];
    all(document, '[data-nb-faq-topic]').forEach(function (el) {
      var last = groups[groups.length - 1];
      if (el.hasAttribute('data-nb-faq-continue') && last) {
        last.els.push(el);
      } else {
        var icon = el.querySelector('[data-nb-faq-icon]');
        groups.push({
          id: el.id,
          title: el.getAttribute('data-title') || el.id,
          icon: icon ? icon.innerHTML : '',
          els: [el]
        });
      }
    });
    groups.forEach(function (g) {
      g.items = [];
      g.els.forEach(function (el) {
        g.items = g.items.concat(all(el, '[data-nb-faq-item]'));
      });
    });
    return groups;
  }

  function init() {
    var hub = document.querySelector('[data-nb-faq-hub]');
    var groups = collectGroups();
    if (!groups.length) return;

    var tabs = !!hub && hub.getAttribute('data-mode') === 'tabs';
    var singleOpen = !!hub && hub.hasAttribute('data-single-open');
    var nav = hub && hub.querySelector('[data-nb-faq-nav]');
    var input = hub && hub.querySelector('[data-nb-faq-search]');
    var clearBtn = hub && hub.querySelector('[data-nb-faq-clear]');
    var status = hub && hub.querySelector('[data-nb-faq-status]');
    var empty = hub && hub.querySelector('[data-nb-faq-empty]');
    var items = [];
    var links = {};
    var active = null;
    var searching = false;

    groups.forEach(function (g) { items = items.concat(g.items); });

    var copyLabel = (hub && hub.getAttribute('data-copy-label')) || 'Copy link';
    var copiedLabel = (hub && hub.getAttribute('data-copied-label')) || 'Link copied';

    items.forEach(function (item) {
      var q = item.querySelector('[data-nb-faq-q]');
      item._nbfQ = q;
      item._nbfQText = q ? q.textContent : '';
      item._nbfText = normalise(item.textContent);
      var label = item.querySelector('[data-nb-faq-copy-label]');
      if (label) label.textContent = copyLabel;
    });

    function groupOf(el) {
      for (var i = 0; i < groups.length; i++) {
        for (var j = 0; j < groups[i].els.length; j++) {
          if (groups[i].els[j].contains(el)) return groups[i];
        }
      }
      return null;
    }

    function groupById(id) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].id === id) return groups[i];
      }
      return null;
    }

    function markLastVisible() {
      var topics = all(document, '[data-nb-faq-topic]');
      var last = null;
      topics.forEach(function (el) {
        el.classList.remove('is-last-visible');
        if (!el.hidden && !el.classList.contains('is-off')) last = el;
      });
      if (last) last.classList.add('is-last-visible');
    }

    /* Topic bar */
    if (nav) {
      nav.innerHTML = '';
      groups.forEach(function (g) {
        var a = document.createElement('a');
        a.className = 'nb-faq__nav-link';
        a.href = '#' + g.id;
        a.innerHTML =
          (g.icon ? '<span class="nb-faq__nav-icon" aria-hidden="true">' + g.icon + '</span>' : '') +
          '<span class="nb-faq__nav-text"></span><span class="nb-faq__nav-count"></span>';
        a.querySelector('.nb-faq__nav-text').textContent = g.title;
        a.addEventListener('click', function (event) {
          event.preventDefault();
          clearSearch();
          activate(g);
          scrollToTopics();
        });
        nav.appendChild(a);
        links[g.id] = a;
      });
    }

    function setCounts() {
      groups.forEach(function (g) {
        var link = links[g.id];
        if (!link) return;
        var n = g.items.filter(function (item) { return !item.hidden; }).length;
        link.querySelector('.nb-faq__nav-count').textContent = n;
        link.classList.toggle('is-empty', searching && n === 0);
      });
    }

    function markLink(id) {
      Object.keys(links).forEach(function (key) {
        var link = links[key];
        var on = key === id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
          if (nav.scrollWidth > nav.clientWidth) {
            nav.scrollTo({ left: link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2, behavior: 'smooth' });
          }
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function activate(g) {
      if (!g) return;
      active = g.id;
      if (tabs) {
        groups.forEach(function (other) {
          other.els.forEach(function (el) { el.classList.toggle('is-off', other !== g); });
        });
        markLastVisible();
      }
      markLink(g.id);
    }

    function scrollToTopics() {
      var target = (groupById(active) || groups[0]).els[0];
      var top = target.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function openItem(item, scroll) {
      clearSearch();
      activate(groupOf(item));
      item.open = true;
      if (scroll) {
        requestAnimationFrame(function () {
          item.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    function goTo(hash, scroll) {
      var id = decodeURIComponent((hash || '').replace(/^#/, ''));
      if (!id) return false;
      var el = document.getElementById(id);
      if (!el) return false;
      if (el.hasAttribute('data-nb-faq-item')) {
        openItem(el, scroll);
        return true;
      }
      if (el.hasAttribute('data-nb-faq-topic')) {
        clearSearch();
        activate(groupOf(el));
        if (scroll) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      return false;
    }

    /* All topics shown: highlight the topic being read. */
    if (!tabs && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (searching) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var g = groupOf(entry.target);
            if (g) markLink(g.id);
          }
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach(function (g) { g.els.forEach(function (el) { observer.observe(el); }); });
    }

    /* Accordion + copy link */
    items.forEach(function (item) {
      if (item._nbfBound) return;
      item._nbfBound = true;

      item.addEventListener('toggle', function () {
        if (!item.open || !singleOpen) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });

      var btn = item.querySelector('[data-nb-faq-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var label = btn.querySelector('[data-nb-faq-copy-label]');
        var url = location.origin + location.pathname + '#' + item.id;
        function done() {
          btn.classList.add('is-done');
          if (label) label.textContent = copiedLabel;
          setTimeout(function () {
            btn.classList.remove('is-done');
            if (label) label.textContent = copyLabel;
          }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else {
          done();
        }
      });
    });

    /* Popular questions */
    var popular = hub && hub.querySelector('[data-nb-faq-popular]');
    var popularList = hub && hub.querySelector('[data-nb-faq-popular-list]');
    if (popular && popularList) {
      popularList.innerHTML = '';
      var featured = items.filter(function (item) { return item.hasAttribute('data-nb-faq-featured'); });
      featured.forEach(function (item) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'nb-faq__chip';
        chip.textContent = item._nbfQText;
        chip.addEventListener('click', function () {
          openItem(item, true);
        });
        popularList.appendChild(chip);
      });
      popular.hidden = featured.length === 0;
    }

    /* Search */
    function setQuestion(item, words) {
      var q = item._nbfQ;
      if (!q) return;
      if (!words || !words.length) {
        q.textContent = item._nbfQText;
        return;
      }
      var pattern = new RegExp('(' + words.map(escapeRegExp).join('|') + ')', 'gi');
      q.textContent = '';
      item._nbfQText.split(pattern).forEach(function (part, i) {
        if (!part) return;
        if (i % 2) {
          var mark = document.createElement('mark');
          mark.textContent = part;
          q.appendChild(mark);
        } else {
          q.appendChild(document.createTextNode(part));
        }
      });
    }

    function message(count) {
      var template = count === 1 ? hub.getAttribute('data-results-one') : hub.getAttribute('data-results-many');
      return (template || '').replace('[count]', count);
    }

    function runSearch() {
      var raw = input ? input.value.trim() : '';
      var query = normalise(raw);
      if (clearBtn) clearBtn.hidden = !raw;
      if (!query) {
        clearSearch();
        return;
      }

      var words = query.split(' ').filter(Boolean);
      var marks = raw.split(/\s+/).filter(Boolean);
      var total = 0;
      searching = true;

      groups.forEach(function (g) {
        var groupHits = 0;
        g.els.forEach(function (el) {
          var hits = 0;
          all(el, '[data-nb-faq-item]').forEach(function (item) {
            var match = words.every(function (w) { return item._nbfText.indexOf(w) !== -1; });
            item.hidden = !match;
            setQuestion(item, match ? marks : null);
            if (match) hits++;
          });
          el._nbfHits = hits;
          groupHits += hits;
        });
        // Keep the first section of a topic for its heading when a later part matches.
        g.els.forEach(function (el, i) {
          el.classList.remove('is-off');
          el.hidden = groupHits === 0 || (i > 0 && el._nbfHits === 0);
        });
        total += groupHits;
      });

      setCounts();
      markLink(null);
      markLastVisible();
      if (status) status.textContent = total ? message(total) : '';
      if (empty) empty.hidden = total > 0;
    }

    function clearSearch() {
      if (!searching) return;
      searching = false;
      if (input) input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      items.forEach(function (item) {
        item.hidden = false;
        setQuestion(item, null);
      });
      groups.forEach(function (g) {
        g.els.forEach(function (el) { el.hidden = false; });
      });
      if (status) status.textContent = '';
      if (empty) empty.hidden = true;
      setCounts();
      activate(groupById(active) || groups[0]);
    }

    if (input && !input._nbfBound) {
      input._nbfBound = true;
      var timer = null;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { state && state.runSearch(); }, 120);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') state && state.clearSearch();
      });
      var form = hub.querySelector('[data-nb-faq-search-form]');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          state && state.runSearch();
          input.blur();
        });
      }
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          state && state.clearSearch();
          input.focus();
        });
      }
      all(hub, '[data-nb-faq-clear-all]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state && state.clearSearch();
          state && state.scrollToTopics();
        });
      });
    }

    /* Start */
    setCounts();
    state = {
      goTo: goTo,
      openItem: openItem,
      activate: activate,
      groupOf: groupOf,
      runSearch: runSearch,
      clearSearch: clearSearch,
      scrollToTopics: scrollToTopics,
      groups: groups
    };
    if (!goTo(location.hash, true)) activate(groups[0]);
    markLastVisible();
  }

  /* Topic bar stays under the header while the topics are on screen. */
  function trackBar() {
    var frame = null;
    function update() {
      frame = null;
      var top = headerBottom();
      document.documentElement.style.setProperty('--nbf-top', top + 'px');

      var slot = document.querySelector('[data-nb-faq-slot]');
      var bar = slot && slot.querySelector('[data-nb-faq-bar]');
      if (!bar) return;
      var topics = all(document, '[data-nb-faq-topic]').filter(function (el) {
        return !el.hidden && !el.classList.contains('is-off');
      });
      var end = topics.length ? topics[topics.length - 1].getBoundingClientRect().bottom : 0;
      var slotTop = slot.getBoundingClientRect().top;
      var height = bar.offsetHeight;
      var fixed = slotTop < top && end > top + height + 40;
      if (fixed !== bar.classList.contains('is-fixed')) {
        slot.style.minHeight = fixed ? slot.offsetHeight + 'px' : '';
        bar.classList.toggle('is-fixed', fixed);
      }
    }
    function queue() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  function ready() {
    init();
    trackBar();
    window.addEventListener('hashchange', function () {
      if (state) state.goTo(location.hash, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  /* Theme editor */
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (name) {
    document.addEventListener(name, function () {
      setTimeout(init, 0);
    });
  });

  document.addEventListener('shopify:section:select', function (event) {
    var topic = event.target.querySelector('[data-nb-faq-topic]');
    if (state && topic) state.activate(state.groupOf(topic));
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target;
    if (state && item.hasAttribute && item.hasAttribute('data-nb-faq-item')) {
      state.openItem(item, false);
    }
  });
})();
